import { MetadataEntityFieldData, MetadataEntityFieldType } from '../model';
import { getMetadataEntityFieldType } from './get.entity.field.type';

// Field types that have a known shape for filter matching / picker rendering. uiOverrides is
// honored only when the override points to one of these. If a field uses the reverse pattern
// (e.g. PurchaseOrder.billingCompany — storage Lookup, uiOverrides EmbeddedEntity for form
// rendering), the override would route filter code to a switch default / break that drops
// items or filters; we fall back to the raw storage type instead.
export const FETCHABLE_PICKER_TYPES: ReadonlySet<MetadataEntityFieldType> = new Set([
    MetadataEntityFieldType.Enum,
    MetadataEntityFieldType.Flag,
    MetadataEntityFieldType.Tag,
    MetadataEntityFieldType.String,
    MetadataEntityFieldType.Boolean,
    MetadataEntityFieldType.Parent,
    MetadataEntityFieldType.Lookup,
]);

// Resolve the effective field used by every filter-shape consumer (FE chip search / label /
// selection reconciliation / has-value; BE entity-strategy buildMatch classification). Single
// source of truth so FE and BE can't diverge on the storage-vs-override resolution policy.
export function getEffectiveFilterField(field: MetadataEntityFieldData): MetadataEntityFieldData {

    if (!field?.uiOverrides) return field;

    const effective = { ...field, ...field.uiOverrides } as MetadataEntityFieldData;
    const effectiveType = getMetadataEntityFieldType(effective);

    return FETCHABLE_PICKER_TYPES.has(effectiveType) ? effective : field;
}
